import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { rem } from 'polished';
import { colors } from '@whitelabel/global-theme/colors';
import { themeColor, transparentizeColor } from '@whitelabel/helpers/style/colors';
import { zIndex } from '@whitelabel/helpers/style/zIndex';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import { focusStyle } from '@whitelabel/helpers/style/utils';
import { fontWeight, lineHeight } from '@whitelabel/helpers/style/type';
import Button from '../Button';

export const StyledSpan = styled(motion.span)`
  margin-inline-start: 0.5rem;
  font-size: 1.125rem;
  font-weight: ${fontWeight('bold')};
  text-transform: none;
  line-height: ${lineHeight('headings')};
  display: none;

  &::first-letter {
    text-transform: uppercase;
  }

  ${mediaBreakpointUp('md')`
    display: block;
  `};
`;

export const StyledContactHoverButton = styled(Button)`
  border: ${rem(2)} solid ${colors.white};
  border-radius: ${rem(100)};
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  color: ${colors.white};
  padding: ${rem(14)};
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
  width: auto;
  &:not(:disabled):not(.disabled):hover {
    background: ${themeColor('info')};
    color: ${colors.white};
    border-color: ${colors.white};
    box-shadow: 0 0 1rem 0 ${transparentizeColor(0.2, themeColor('info'))};
  }
  &:not(:disabled):not(.disabled):focus {
    background: ${themeColor('info')};
    color: ${colors.white};
    border: none;
    ${focusStyle}
  }
  z-index: ${zIndex('content')};
  > svg {
    margin-inline-end: 0;
  }

  ${mediaBreakpointUp('md')`
    right:1.25rem;
    bottom:1.25rem;
  `};

  background: ${themeColor('info')};
`;

const turning = keyframes`
  100% {
    transform: rotate(1turn);
  }
`;
export const StyledLoading = styled.div`
  width: 24px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, ${colors.white} 94%, #0000) top/4px 4px no-repeat,
    conic-gradient(#0000 30%, ${colors.white});
  mask: radial-gradient(farthest-side, #0000 calc(100% - 4px), #000 0);
  animation: ${turning} 1s infinite linear;
`;
